import React from 'react';
import '../Styling/cards.css';
import '../Styling/days.css';
import ContactForm from '../Components/contactForm';



export default function Day1() {
    return (<>
    <div id="rootAlign">
<div className='dayDescription'>
    Celebrate Day 1 by immersing yourself in the vibrant tapestry of Jaipur's rich cultural heritage. Begin your journey with an insightful introduction to the Pink City, delving into its architectural marvels, cultural significance, and fascinating history. Explore the bustling markets during a Bazar Walk, where traditional crafts, intricate jewelry, and vibrant clothing await discovery. Uncover the age-old cottage industries during Cottage Economy Exploration, witnessing the dedication and skill behind block printing and pottery. Indulge your taste buds with Rajasthani street food during Street Food Delights, a flavorful journey through the region's culinary identity. Conclude the day with a spiritual and enlightening experience during the Spirituality and Religion Tour, visiting iconic temples and gaining insights into Jaipur's diverse spiritual fabric.
    </div>


    <div className="dayHeading day1Heading"></div>


    <div className="daysContainer bgImgRight bgImg1">
      <div className='align'>

      <div className="dayDesc day1Desc1"></div>
      <div className="dayCard day1Card1"></div>
      </div>
    </div>


    <div className="daysContainer bgImgLeft bgImg2">
      <div className='align'>

      <div className="dayDesc day1Desc2"></div>
      <div className="dayCard day1Card2"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg3">
      <div className='align'>   

      <div className="dayDesc day1Desc3"></div>
      <div className="dayCard day1Card3"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg4">
      <div className='align'>

      <div className="dayDesc day1Desc4"></div>
      <div className="dayCard day1Card4"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg5">
      <div className='align'>

      <div className="dayDesc day1Desc5"></div>
      <div className="dayCard day1Card5"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg6">
      <div className='align'>

      <div className="dayDesc day1Desc6"></div>
      <div className="dayCard day1Card6"></div>
      </div>
    </div>

    </div>
<ContactForm/>

    </> );
};